import { render, staticRenderFns } from "./SectionStyle2.vue?vue&type=template&id=0bbf68da"
import script from "./SectionStyle2.vue?vue&type=script&lang=js"
export * from "./SectionStyle2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports